import axios from "axios";
import settings from "../settings";
import router from "@/router";

let newTagData = {
    is_new: true,
    name: null,
    description: null,
    level: null,
    subtag_id: null
};

let initialState = {
    loadingTagList: false,
    loadingTagData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    activeTag: {},
    tags: [],
    searchTagString: "",
    errorMessage: "",
    tagCount: 0
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async getTagList({commit}, search = null) {
            await commit("setTagListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/tags", {params: search});
                if (response?.data?.success === 1) {
                    let data = response.data;
                    await commit("addTags", data.tags);
                    await commit("setTagCount", data.total_tags_count);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setTagListLoading", false);
        },
        async getTagData({commit}, tagId) {
            commit("setTagDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/tag/" + tagId);
                if (response.data?.success === 1) {
                    let data = response.data;
                    commit("setActiveTag", data.tag_data);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setTagDataLoading", false);
        },
        async submitTagUpdate({commit, dispatch}, payload) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setTagDataLoading", true);
            try {
                let response = await axios.post(settings.api_url + "/tag/", payload);
                if (response.status === 200 && response.data.success === 1) {
                    await dispatch("getTagList");
                    await commit("setRequestSuccess", true);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setTagDataLoading", false);
        },
        async deleteTag({commit, dispatch}, {tagId}) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setTagListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/tag/", {params: {tag_id: tagId}});
                if (response && response.data.success === 1) {
                    await dispatch("getTagList");
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setTagListLoading", false);
            router.push("/tags");
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addTags(state, tags) {
            state.tags = tags;
        },
        setActiveTag(state, tag) {
            state.activeTag = {...tag};
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveTag(state) {
            state.activeTag = {};
        },
        addNewTag(state) {
            state.activeTag = {...newTagData};
        },
        updateActiveTagProperty(state, {prop, value}) {
            state.activeTag = {
                ...state.activeTag,
                [prop]: value
            };
        },
        updateTagSearch(state, payload) {
            state.searchTagString = payload.term;
            this.dispatch("TagStore/getTagList", {
                search: state.searchTagString
            });
        },
        resetTagSearch(state) {
            state.searchTagString = "";
        },
        setTagListLoading(state, value) {
            state.loadingTagList = value;
        },
        setTagDataLoading(state, value) {
            state.loadingTagData = value;
        },
        setTagCount(state, value) {
            state.tagCount = value;
        }
    }
};
